import { Component, Input } from "@angular/core";
import { Groupe } from "../../../interfaces/Groupe";

@Component({
  selector: "app-informations",
  templateUrl: "./informations.component.html",
  standalone: false,
})
export class InformationsComponent {
  @Input() groupe: Groupe;
}
